import type { AxiosInstance } from 'axios';
import type { paths } from '../schema';
import type { RequestOptions, RequestOptionsWithParams } from './types';
import { curry1 } from './utils';

type LoggableActiviitesParams = Required<
  paths['/api/activities/loggable']['get']['parameters']
>['query'] & {
  custom_object_id?: string;
  page?: number;
  page_size?: number;
  search?: string;
};

type LoggableActivitiesResponse =
  paths['/api/activities/loggable']['get']['responses']['200']['content']['application/json'];

type GetActivityResponse =
  paths['/api/activities/{activity_identifier}']['get']['responses']['200']['content']['application/json'];

type GetActivityFieldsResponse =
  paths['/api/activities/{activity_identifier}/fields']['get']['responses']['200']['content']['application/json'];

export const getActivity = async (
  instance: AxiosInstance,
  id: string,
  options?: RequestOptions
): Promise<GetActivityResponse> => {
  const res = await instance.get<GetActivityResponse>(
    `/activities/${id}`,
    options
  );

  return res.data;
};

export const getActivityFields = async (
  instance: AxiosInstance,
  id: string,
  options?: RequestOptions
): Promise<GetActivityFieldsResponse> => {
  const res = await instance.get<GetActivityFieldsResponse>(
    `/activities/${id}/fields`,
    options
  );

  return res.data;
};

export const getLoggableActivities = async (
  instance: AxiosInstance,
  options: RequestOptionsWithParams<LoggableActiviitesParams> = {}
): Promise<LoggableActivitiesResponse> => {
  const res = await instance.get<LoggableActivitiesResponse>(
    `/activities/loggable`,
    options
  );

  return res.data;
};

export class ActivitiesService {
  public getActivity;
  public getActivityFields;
  public getLoggableActivities;

  constructor(private instance: AxiosInstance) {
    this.getActivity = curry1(getActivity)(this.instance);
    this.getActivityFields = curry1(getActivityFields)(this.instance);
    this.getLoggableActivities = curry1(getLoggableActivities)(this.instance);
  }
}
